export { default } from "./RowTransaction-component";
